module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Адреса\n    "), (_vm.total) ? _c('span', [_vm._v("(" + _vm._s(_vm.total) + ")")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'address-add'
      }
    }
  }, [_vm._v("+ Добавить адрес")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Дата снятия абонплаты")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "input-id": "bill-datetime",
      "input-class": "form-control",
      "type": "datetime",
      "placeholder": "Выберите дату и время"
    },
    model: {
      value: (_vm.bill_datetime),
      callback: function($$v) {
        _vm.bill_datetime = $$v
      },
      expression: "bill_datetime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.applyBilling.apply(null, arguments)
      }
    }
  }, [_vm._v("применить снятие абонплаты")])])])]), _vm._v(" "), _c('resource-list', {
    attrs: {
      "url": "/addresses",
      "current-sort": "name",
      "init-sort-type": "asc",
      "resource-name": "addresses",
      "show-per-page": false,
      "action-routes": _vm.actionRoutes,
      "fields": _vm.fields,
      "filters": _vm.filters
    },
    on: {
      "total": _vm.updateTotal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b38f4e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/address/Addresses.vue
// module id = 636
// module chunks = 0